import { QUESTIONS_ROUTES } from '../../constants/_routes'
import questionsTypes from '../../constants/questionsTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'

const create_question_request = () => {
  return {
    type: questionsTypes.create.request
  }
}

const create_question_success = (response) => {
  return {
    type: questionsTypes.create.success,
    payload: response.data.question
  }
}

const create_question_failure = (messages) => {
  return {
    type: questionsTypes.create.failure,
    payload: messages
  }
}

const create_question = (values) => {
  return function (dispatch) {
    // Before Request
    dispatch(create_question_request())

    // Request
    axios.post(
      QUESTIONS_ROUTES.create,
      values
    ).then( response => {
      // success
      dispatch( create_question_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error creating question."]
      }
      // dispatch( try_force_logoff(error.response) )
      window.showSnackbar('error', errors)
      dispatch( create_question_failure(errors))
    })
  }

}

export {
  create_question
}



// WEBPACK FOOTER //
// ./src/js/actions/questions/create.js